<template>
    <div>
        <b-row v-for="(area) in $store.getters[ store + '/' + areasGetter ]" :id="area.id" :key="area.id" class="mb-2">
            <b-col md='7'>
              <v-select 
                  :disabled="$store.getters[ store + '/' + 'isReadOnly']"
                  :placeholder="$t('PLANS_AREA_PLACEHOLDER')" 
                  @input="(value)=> $store.commit( store +  '/' + updateAreaMutation, {id:area.id, key:'geofence_id', value})"
                  :value="$store.getters[ store +  '/' + areaGetter ](area.id, 'geofence_id')"
                  :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                  :getOptionLabel="area => area.name" 
                  :options="$store.getters[store + '/' + optionsGetter]" 
                  :reduce="area => area.geofence_id" 
              />
            </b-col>
            <b-col md='3'>
              <b-button v-ripple.400="'rgba(234, 84, 85, 0.15)'" variant="outline-danger" class="btn-sm h-100" @click="()=> $store.commit( store +  '/' + removeAreaMutation, {id:area.id})">
                <feather-icon icon="XIcon"/>
              </b-button>
            </b-col>
        </b-row>

        <b-row class="mb-2" align-v="start">
          <b-col md="auto">
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'"variant="primary" @click="()=> $store.commit( store + '/' + addAreaMutation )">
              <feather-icon 
                icon="PlusIcon" 
                class="mr-25"
              />
              <span>{{ $t('PLANS_ADD_NEW_AREA_LABEL')}}</span>
            </b-button>
          </b-col>
          <b-col md="auto">
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="danger" @click="()=> $store.commit( store + '/' + removeAllAreasMutation )">
            <feather-icon 
              icon="XIcon" 
              class="mr-25"
            />
            <span>{{ $t('PLANS_DELETE_ALL_AREAS_LABEL') + ' ' + '(' + $store.getters[ store + '/' + areasGetter ].length + ')'}}</span>
            </b-button>
          </b-col>

          
        </b-row>
  </div>
</template>

<script>

import vSelect from 'vue-select'

import {
  BForm, 
  BFormGroup, 
  BFormInput, 
  BRow, 
  BCol, 
  BButton,
} from 'bootstrap-vue'

import Ripple from 'vue-ripple-directive'


export default {
  components: {
    vSelect,
    BForm, 
    BRow, 
    BCol, 
    BButton,
    BFormGroup, 
    BFormInput,
  },
  directives: { Ripple },
  props: {
    store: {
      type: String,
      required: true

    },
    optionsGetter: {
      type: String,
      default:'areaOptions'
    },
    areasGetter: {
      type: String,
      default:'areasList'
    },
    areaGetter: {
      type: String,
      default:'area'
    },
    addAreaMutation: {
      type: String,
      default:'addArea'
    },
    updateAreaMutation: {
      type: String,
      default:'updateArea'
    },
    removeAreaMutation: {
      type: String,
      default:'removeArea'
    },
    removeAllAreasMutation: {
      type: String,
      default:'removeAllAreas'
    }
  }
}
</script>

<style lang="scss" scoped>
.repeater-form {
  overflow: visible;
  transition: .35s height;
}
</style>
